import React, { useMemo } from 'react'
import Breadcrumps from '@blocks/Breadcrumps'
import MainContainer from '@blocks/MainContainer'
import MembershipController from '@club/customer/api/MembershipController'
import useAuth from '@hooks/useAuth'
import useRequestEffect from '@hooks/useRequestEffect'
import useStatic from '@hooks/useStatic'
import useTitle from '@hooks/useTitle'
import { useParams } from 'react-router'
import { route } from '@helpers'
import EmphasizedContent from '@blocks/EmphasizedContent'
import Grid from '@blocks/Grid'
import MemberSalonsTable from './components/SalonsTable/MemberSalonsTable'

export default function MemberPage() {
    const { id } = useParams<{ id: string }>()
    const auth = useAuth<Resources.ClubOwner>()

    const [member, setMember] = useRequestEffect(() => MembershipController.show(auth.user.club.id, id))
    const name = member ? `${member.first_name} ${member.last_name}` : 'Loading...'

    useTitle(`Member: ${name}`)

    const heading = useMemo(() => <Breadcrumps items={[
        { name: auth.user.club.name, url: route("club:customer") }, 
        { name: "Members", url: route("club:owner:members") },
        { name }
    ]} />, [name])

    if (!member)
        return <MainContainer heading={heading} />

    return (
        <MainContainer heading={heading}>
            <Grid>
                <Grid gap="5px">
                    <h1 className="h3">{member.first_name} {member.last_name}</h1>
                    <small><a href={`mailto:${member.email}`}>{member.email}</a></small>
                </Grid>
                <Grid columns="3">
                    <EmphasizedContent>
                        <Grid gap="5px">
                            <p>Salons</p>
                            <h3>{member.salons_count}</h3>
                            <small>Total</small>
                        </Grid>
                    </EmphasizedContent>
                    <EmphasizedContent>
                        <Grid gap="5px">
                            <p>Acceptances</p>
                            <h3>{member.acceptances_count}</h3>
                            <small>Total</small>
                        </Grid>
                    </EmphasizedContent>
                    <EmphasizedContent>
                        <Grid gap="5px">
                            <p>Awards</p>
                            <h3>{member.awards_count}</h3>
                            <small>Total</small>
                        </Grid>
                    </EmphasizedContent>
                </Grid>
                <MemberSalonsTable member={member} />
            </Grid>
        </MainContainer>
    )
}